/* eslint-disable max-lines */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */

import { isAuthorMode } from '@site/js/utils/author-mode';

import { getFrontendValidationErrors, printFormValidationErrors } from '../form/form-validation';

(function() {
  'use strict';
  const LOADER_ID = 'powerportal-loader';
  const RECAPTCHA_FIELD_NAME = 'recaptcha';
  const ARIA_INVALID_ATTR = 'aria-invalid';
  const MANDATORY_FIELD_ERROR = 'This is a mandatory field.';
  const REQUIRED_MESSAGE_ATTR = 'data-cmp-required-message';
  const FORM_CONTEXT_SELECTOR = 'formcontext';
  const NEW_REGISTRATION_SELECTOR = 'newregistration';
  let signupToken = null;
  let isTokenReady = false;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function buildSelectorUrl(selector) {
    const path = window.location.pathname
      .replace(/\.html$/, '')
      .replace(/\/+$/, '');
    const url = `${path}.${selector}.json`;
    console.log('[PP-DEBUG][new-user] buildSelectorUrl ->', url);
    return url;
  }

  function hasTokenInUrl() {
    return Boolean(new URLSearchParams(window.location.search).get('token'));
  }


  function isExperienceFragmentAuthorMode() {
    try {
      return Boolean(window.Granite?.author);
    } catch {
      return false;
    }
  }

  function hideLoader(formEl) {
    document.querySelectorAll(`#${LOADER_ID}`).forEach(node => node.remove());
    if (formEl) {
      formEl.removeAttribute('aria-busy');
    }
  }

  /**
   * Gathers all form values into the submission payload. The e-mail address is never included -
   * the backend derives it exclusively from the validated opaque token (see SignupNewUserServlet).
   */
  function collectRequestBody(fields) {
    const countryPhoneCode = document.querySelector('.iti__selected-dial-code');
    const phoneCode = countryPhoneCode ? countryPhoneCode.textContent : '';
    const preferences = Array.from(
      document.querySelectorAll('input.cmp-form-options__field--checkbox[name="My Preferences"]:checked')
    ).map(checkbox => checkbox.value);

    return {
      token: fields.signupToken,
      firstName: fields.firstNameInput ? fields.firstNameInput.value.trim() : '',
      lastName: fields.lastNameInput ? fields.lastNameInput.value.trim() : '',
      countryName: fields.countrySelect ? fields.countrySelect.value : '',
      stateName: fields.stateSelect ? fields.stateSelect.value : '',
      company: fields.companyInput ? fields.companyInput.value.trim() : '',
      companyWebsite: fields.companyWebsiteInput ? fields.companyWebsiteInput.value.trim() : '',
      phone: fields.phoneInput ? `${phoneCode} ${fields.phoneInput.value.trim()}` : '',
      streetNr: fields.streetInput ? fields.streetInput.value.trim() : '',
      postalCode: fields.postalCodeInput ? fields.postalCodeInput.value.trim() : '',
      city: fields.cityInput ? fields.cityInput.value.trim() : '',
      profile: fields.profileSelect ? fields.profileSelect.value : '',
      requestsCop: fields.requestsCopCheckbox?.checked || false,
      businessJustification: fields.businessJustificationInput ? fields.businessJustificationInput.value.trim() : '',
      slaContractNumber: fields.slaContractNumberInput ? fields.slaContractNumberInput.value.trim() : '',
      preferences,
      'g-recaptcha-response': fields.captchaToken
    };
  }

  function init() {
    // Get all input fields by their data-input-name attributes
    const firstNameInput = document.querySelector('input[data-input-name="firstName"]');
    const lastNameInput = document.querySelector('input[data-input-name="lastName"]');
    const emailInput = document.getElementById('email-container-new-user');
    const companyInput = document.querySelector('input[data-input-name="companyName"]');
    // Not yet authored on the form as of this change - read defensively so the payload picks it
    // up automatically once the "Company/Organization Website" field is added to the XF content.
    const companyWebsiteInput = document.querySelector('input[data-input-name="companyWebsite"]');
    const streetInput = document.querySelector('input[data-input-name="street"]');
    const postalCodeInput = document.querySelector('input[data-input-name="postalCode"]');
    const cityInput = document.querySelector('input[data-input-name="city"]');
    const phoneInput = document.querySelector('input[data-input-name="phone"]');
    const countrySelect = document.querySelector('.cmp-countriesoptions__country select');
    const stateSelect = document.querySelector('.cmp-countriesoptions__state select');
    const profileSelect = document.querySelector('select[name="profile"]');
    const requestsCopCheckbox = document.querySelector('input.cmp-form-options__field--checkbox[name="My Application Access"]');
    const businessJustificationInput = document.getElementById('cop-access-bussiness-justification');
    const slaContractNumberInput = document.getElementById('cop-access-sla');
    const submitButton = document.getElementById('signup-form-new-user-submit');
    const formElement = submitButton ? submitButton.closest('form') : null;
    console.log('[PP-DEBUG][new-user] init: submitButton found?', Boolean(submitButton));

    const requestsCopFieldNode = requestsCopCheckbox?.closest('.cmp-form-options');
    const clearRequestsCopRequired = () => {
      requestsCopFieldNode?.querySelectorAll('[required]').forEach(el => el.removeAttribute('required'));
      requestsCopFieldNode?.classList.remove('is-empty', 'is-invalid');
      requestsCopFieldNode?.querySelector('.cmp-form__error-message')?.remove();
    };
    clearRequestsCopRequired();

    // Disable email input - value is resolved from the token server-side, never user-editable
    if (emailInput) {emailInput.disabled = true;}

    // Set error messages for dropdowns to ensure validation works
    if (countrySelect) {
      // Remove form attribute so it's part of the main form validation
      countrySelect.removeAttribute('form');
      if (!countrySelect.hasAttribute(REQUIRED_MESSAGE_ATTR)) {
        countrySelect.setAttribute(REQUIRED_MESSAGE_ATTR, MANDATORY_FIELD_ERROR);
      }
      // Ensure the select has required attribute
      countrySelect.setAttribute('required', 'required');
    }
    if (stateSelect) {
      // Remove form attribute so it's part of the main form validation
      stateSelect.removeAttribute('form');
      if (!stateSelect.hasAttribute(REQUIRED_MESSAGE_ATTR)) {
        stateSelect.setAttribute(REQUIRED_MESSAGE_ATTR, MANDATORY_FIELD_ERROR);
      }
    }

    const preferenceCheckboxes = document.querySelectorAll('input.cmp-form-options__field--checkbox[name="My Preferences"]');
    if (Array.from(preferenceCheckboxes).some(checkbox => checkbox.checked)) {
      preferenceCheckboxes.forEach(checkbox => {
        checkbox.required = false;
      });
    }

    // Submit stays enabled at all times - required-field/captcha problems are surfaced as error
    // messages on click (see submit handler) rather than by disabling the button up front.
    const validateForm = () => {
      if (submitButton) {
        submitButton.disabled = false;
      }
    };


    const businessJustificationWrapper = businessJustificationInput?.closest('.text');
    const slaContractNumberWrapper = slaContractNumberInput?.closest('.text');
    const clearFieldError = (wrapperEl, inputEl) => {
      wrapperEl?.classList.remove('is-empty', 'is-invalid');
      wrapperEl?.querySelector('.cmp-form__error-message')?.remove();
      inputEl?.setAttribute(ARIA_INVALID_ATTR, 'false');
    };
    const updateCopAccessFieldsVisibility = () => {
      clearRequestsCopRequired();
      const showCopFields = requestsCopCheckbox?.checked || false;
      if (businessJustificationInput) {
        businessJustificationInput.disabled = !showCopFields;
        if (!showCopFields) {
          businessJustificationInput.value = '';
          clearFieldError(businessJustificationWrapper, businessJustificationInput);
        }
      }
      if (slaContractNumberInput) {
        slaContractNumberInput.disabled = !showCopFields;
        if (!showCopFields) {
          slaContractNumberInput.value = '';
          clearFieldError(slaContractNumberWrapper, slaContractNumberInput);
        }
      }
      if (businessJustificationWrapper) {
        businessJustificationWrapper.style.display = showCopFields ? '' : 'none';
      }
      if (slaContractNumberWrapper) {
        slaContractNumberWrapper.style.display = showCopFields ? '' : 'none';
      }
    };
    // Apply the initial state on load - without this call the fields stay visible regardless of
    // the checkbox's default (unchecked) state until the visitor's first toggle.
    updateCopAccessFieldsVisibility();

    // Global captcha callbacks
    window.captchaSolved = () => new Promise(resolve => {
      console.log('[PP-DEBUG][new-user] captchaSolved callback fired');
      document.getElementsByName(RECAPTCHA_FIELD_NAME)[0].required = false;
      document.querySelector('.cmp-form-captcha')?.classList.remove('is-empty');
      document.querySelector('#recaptcha')?.setAttribute(ARIA_INVALID_ATTR, 'false');
      validateForm();
      resolve();
    });

    window.recaptchaExpired = () => {
      const recaptchaInput = document.getElementsByName(RECAPTCHA_FIELD_NAME)[0];
      recaptchaInput.required = true;
      recaptchaInput.setAttribute(ARIA_INVALID_ATTR, 'true');
      validateForm();
    };

    // Add listeners
    [firstNameInput, lastNameInput, emailInput, companyInput, companyWebsiteInput,
     streetInput, postalCodeInput, cityInput, phoneInput, businessJustificationInput,
     slaContractNumberInput].forEach(input => {
      input?.addEventListener('input', validateForm);
    });
    countrySelect?.addEventListener('change', validateForm);
    stateSelect?.addEventListener('change', validateForm);
    profileSelect?.addEventListener('change', validateForm);
    requestsCopCheckbox?.addEventListener('change', validateForm);
    requestsCopCheckbox?.addEventListener('change', updateCopAccessFieldsVisibility);

    // // Edge Case:- disabled the postal code number check as LONDON has number+alphbate
    // postalCodeInput?.addEventListener('input', function () {
    //   this.value = this.value.replace(/[^0-9]/g, '')
    // })

    // Numbers only for phone (max 13 digits)
    phoneInput?.addEventListener('input', function () {
      let numericValue = this.value.replace(/[^0-9]/g, '')
      // if (numericValue.length > 13) {
      //   numericValue = numericValue.slice(0, 13)
      // }
      this.value = numericValue;
    })

    validateForm()

    resolveSignupToken(formElement, emailInput, validateForm);

    // Handle submit button click
    if (submitButton) {
      submitButton.addEventListener('click', function(event) {
        event.preventDefault();
        if (document.getElementById(LOADER_ID)) {
          return;
        }

        const validationErrors = getFrontendValidationErrors(formElement);
        if (validationErrors.size > 0) {
          printFormValidationErrors(validationErrors);
          return;
        }

        if (!isTokenReady) {
          return;
        }

        const captchaToken = typeof grecaptcha !== 'undefined' ? window.grecaptcha.getResponse() : '';
        if (!captchaToken) {
          const recaptchaInput = document.getElementsByName(RECAPTCHA_FIELD_NAME)[0];
          if (recaptchaInput) {
            recaptchaInput.required = true;
            recaptchaInput.setAttribute(ARIA_INVALID_ATTR, 'true');
            recaptchaInput.setCustomValidity('Captcha required');
          }
          document.querySelector('.cmp-form-captcha')?.classList.add('is-empty');
          validateForm();
          return;
        }

        const successPageUrl = formElement.getAttribute('data-pp-sign-up-form-success-page-url');
        const errorMessage = formElement.getAttribute('data-pp-sign-up-form-error-message');
        const cleanErrorMessage = errorMessage ? errorMessage.replace(/<[^>]*>/g, '') : 'Something went wrong. Please try again.';
        const requestBody = collectRequestBody({
          firstNameInput, lastNameInput, companyInput, companyWebsiteInput, streetInput,
          postalCodeInput, cityInput, phoneInput, countrySelect, stateSelect, profileSelect,
          requestsCopCheckbox, businessJustificationInput, slaContractNumberInput, signupToken,
          captchaToken
        });

        // Disable button to prevent multiple clicks
        submitButton.disabled = true;
        submitButton.textContent = 'Please wait...';

        const errorMessages = document.querySelectorAll('.cmp-form-text__error-message, [data-component="Infobox"]');
        errorMessages.forEach(error => {
          error.style.display = 'none';
        });

        // Create and show full-page loader
        formElement.setAttribute('aria-busy', 'true');
        const loader = document.createElement('div');
        loader.id = LOADER_ID;
        loader.className = LOADER_ID;
        loader.setAttribute('role', 'status');
        loader.setAttribute('aria-live', 'polite');
        loader.innerHTML = `
          <div class="powerportal-loader__modal">
            <div class="powerportal-loader__spinner"></div>
            <p class="powerportal-loader__text">Processing your request...</p>
          </div>
        `;
        document.body.appendChild(loader);

        const newUserRequestUrl = buildSelectorUrl(NEW_REGISTRATION_SELECTOR);

        fetch(newUserRequestUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        })
        .then(async (response) => {
          const contentType = response.headers.get('content-type') || '';
          const data = contentType.includes('application/json')
            ? await response.json()
            : await response.text();

          return {
            ok: response.ok,
            status: response.status,
            data
          };
        })
        .then(({ ok, status, data }) => {
          hideLoader(formElement);


          if (!ok || status !== 200 || typeof data !== 'object') {
            throw new Error(data?.message || 'Registration submission failed');
          }

          if (successPageUrl && hasTokenInUrl()) {
            window.location.replace(successPageUrl);
          } else {
            submitButton.disabled = false;
            submitButton.textContent = 'Submit';
          }
        })
        .catch(error => {

          alert(error?.name === 'Error' && error.message ? error.message : cleanErrorMessage);

          hideLoader(formElement);

          // Re-enable button
          submitButton.disabled = false;
          submitButton.textContent = 'Submit';
        })
        .finally(() => {
          if (typeof grecaptcha !== 'undefined') {
            window.grecaptcha.reset();
          }
        });
      });
    } else {
      console.warn('Submit button not found');
    }
  }

  function resolveSignupToken(formElement, emailInput, onResolved) {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const homePageUrl = formElement?.getAttribute('data-pp-sign-up-form-home-page-url');
    const linkExpiredPageUrl = formElement?.getAttribute('data-pp-sign-up-form-link-expired-page-url');

    if (!token) {
      if (linkExpiredPageUrl && !isAuthorMode() && !isExperienceFragmentAuthorMode()) {
        window.location.replace(linkExpiredPageUrl);
      }
      return;
    }

    signupToken = token;

    const contextUrl = `${buildSelectorUrl(FORM_CONTEXT_SELECTOR)}?token=${encodeURIComponent(token)}`;

    fetch(contextUrl)
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));

        return { ok: response.ok, data };
      })
      .then(({ ok, data }) => {
        if (!ok || !data?.valid) {
          throw new Error('Invalid or expired signup token');
        }
        if (emailInput && data.email) {
          emailInput.value = data.email;
        }
        // Only now is the token confirmed valid - let the submit button become eligible.
        isTokenReady = true;
        if (typeof onResolved === 'function') {
          onResolved();
        }
      })
      .catch((err) => {
        signupToken = null;
        isTokenReady = false;
        if (linkExpiredPageUrl) {
          window.location.replace(linkExpiredPageUrl);
        }
      });
  }
})();
